module.exports = __webpack_public_path__ + "static/media/slider3.166a2efe.jpg";